import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, WeeklySubmits } from "@/types";

// The current user's submits for the weekly goal window. Scoped server-side to
// whoever is logged in, so it takes no user argument.
export function useGetWeeklySubmits({ enabled }: { enabled: boolean }) {
  return useQuery({
    queryKey: ["weekly-submits"],
    queryFn: async () => {
      const res = await guacHttpClient.get<
        WeeklySubmits,
        HttpResponse<WeeklySubmits>
      >("team-goals/weekly-submits");
      return res.data;
    },
    enabled,
  });
}
